export default "__VITE_ASSET__DXE_cOX4__"